import PateintsChartsWrapper from '../patientcharts/patientchartwrap';
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import useStore from '../../store/zustandstore';
import Orders from '../../orders/orders';
import { eventBus } from '../../utils/eventBus';
import { se } from 'date-fns/locale';
import ToastMessage from '../../utils/mui/righttoptoast';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector } from 'react-redux';
const ModalOverlay = ({ isOpen, onClose,isloaderactive,setFetchedData, fetchedData,modaldata,fetchpcarddata, dob, searchdate }) => {
  const setSidenav = useStore((state) => state.setSidenav);
  const [showOrders, setShowOrders] = useState(false);
const [ordersref, setOrdersref] = useState(false)
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const reduxDate = useSelector((state) => state.filter.currentDate);
const startDateObj = dayjs(modaldata.startdate, "YYYY-MM-DD HH:mm:ss");

// redux date (assume format YYYY-MM-DD)
console.log(modaldata,'modals')
const dtObj = dayjs(reduxDate, "YYYY-MM-DD");
const isSameDate = startDateObj.isSame(dtObj, "day");
  const [toastSeverity, setToastSeverity] = useState("success");
  const handleToastClose = () => {
    setOpenToast(false);
  };

  if (!isOpen) return null;

  const handleToggle = () => {
    if(!showOrders&&!isSameDate){
      setToastMessage('Please schedule an appointment')
setToastSeverity('info')
setOpenToast(true)
return
    }
    if(showOrders){  
      eventBus.emit("fetchSummary")
    }
    setOrdersref(false)
    setShowOrders(!showOrders);
  };

// useEffect(()=>{
// console.log('s')
// },[showOrders])
  return (
    <div className="fixed z-50 flex items-center justify-center w-full bg-black bg-opacity-50 top-16">
      <div className="bg-white shadow-lg w-full h-full relative overflow-hidden">

        {/* Close button */}
        {<button
          className={`absolute ${showOrders?"top-5":"top-2"} right-4 text-black z-50`}
          onClick={()=>{
            if(showOrders){
              setOrdersref(true)
              // eventBus.emit("fetchSummary")
              // setShowOrders(false)
              console.log(ordersref,"orderref from parent")
            }else{
              onClose()
            }
           
          }
        }
        >
          <CloseIcon style={{ width: '34px', height: '34px', color: '#C7C7CB' }} />
        </button>}

        {/* Vertical Orders/Charts toggle button */}
        {<div
          className="absolute top-[20%] -right-6 transform -translate-y-1/2 rotate-90 origin-center 
                     px-6 py-2 rounded-md font-medium text-sm text-white cursor-pointer z-50"
          style={{ backgroundColor: "rgba(225, 121, 84, 1)" }}
          onClick={handleToggle}
        >
          {showOrders ?"Charts" : "Orders"}
        </div>}

        {/* Always render charts in background */}
        <div className="h-full w-full">
          <PateintsChartsWrapper isloaderactive={isloaderactive}      setFetchedData={setFetchedData}
             fetchedData={fetchedData} onClose={onClose} fetchpcarddata={fetchpcarddata} data={modaldata} dob={dob} searchdate={searchdate} />
        </div>

        {/* Orders sliding panel */}
        <div
          className={`absolute top-0 right-0 h-full bg-white shadow-2xl transition-transform duration-500 ease-in-out 
          ${showOrders ? "translate-x-0" : "translate-x-full"} w-[95%]`}
        >
          <div className="max-h-[90vh] h-full overflow-auto">
            <Orders
              setShowOrders={setShowOrders}
              appointmentId={modaldata?.appointmentid}
              startDate={modaldata?.startdate}
              searchdate={searchdate}
ordersref={ordersref}
setOrdersref={setOrdersref}
               showOrders={showOrders}
            />
          </div>
        </div>
    <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </div>
    </div>
  );
};

export default ModalOverlay;
